import { createFeature, createReducer, on } from '@ngrx/store';
import { Country } from '@emi/shared/models';
import * as countryActions from './country-actions';
import * as commonActions from '../common-actions';

export interface CountryState {
    countries: Country[];
    searchedCountries: Country[];
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const countryFeatureKey = 'countryFilters';

const initialState: CountryState = {
    countries: [],
    searchedCountries: [],
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const countryFeature = createFeature({
    name: countryFeatureKey,
    reducer: createReducer(
        initialState,
        on(countryActions.isLoadingCountries, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(countryActions.getCountriesSuccess, (state, { countries }) => {
            return {
                ...state,
                countries,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(countryActions.getCountriesFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(countryActions.searchCountries, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(countryActions.searchCountriesSuccess, (state, { searchText, countries }) => {
            return {
                ...state,
                searchedCountries: countries,
                searchText,
                loading: false,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
